module.exports = __webpack_public_path__ + "img/swiper-14.c4d8c739.png";